import { Component, OnInit } from '@angular/core';
import { tenantInfo } from 'src/app/Models/url';

@Component({
  selector: 'app-safeguardingpolicy',
  templateUrl: './safeguardingpolicy.component.html',
  styleUrls: ['./safeguardingpolicy.component.css']
})
export class SafeguardingpolicyComponent implements OnInit {

  tenantInfo: any = tenantInfo;

  userRole:any;
  constructor() { }

  ngOnInit(): void {
    this.userRole = localStorage.getItem('role');
  }

}
